import React from "react";

import BasicLoader from "./BasicLoader";

const FullScreenLoader = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      left: 0,
      background: "#fff",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "99vh",
    }}
  >
    <BasicLoader />
  </div>
);

export default FullScreenLoader;
